"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class DataType extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'dataType';
        this._name = initParams.name;
        this._dataType = initParams.data_type;
        this._organisationId = initParams.organisation_id;
        this._unitId = initParams.unit_id;
        this._unitDetails = initParams.unit_details;
        this._applyRate = initParams.apply_rate;
        this._rateUnitId = initParams.rate_unit_id;
        this._rateUnitDetails = initParams.rate_unit_details;
        this._categoryId = initParams.category_id;
        this._categoryDetails = initParams.category_details;
        this._global = initParams.global;
        this._defaultRateMultiple = initParams.default_rate_multiple;
        this._defaultMultiple = initParams.default_multiple;
        this.__permission = initParams._permission;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateDataType(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set dataType(value) {
        console.error('Do not set objects this way');
    }
    setDataType(value) {
        return this.dataService.updateDataType(this.id, { data_type: value }, this);
    }
    get dataType() {
        return this._dataType;
    }
    set organisationId(value) {
        console.error('Do not set objects this way');
    }
    setOrganisationId(value) {
        return this.dataService.updateDataType(this.id, { organisation_id: value }, this);
    }
    get organisationId() {
        return this._organisationId;
    }
    set unitId(value) {
        console.error('Do not set objects this way');
    }
    setUnitId(value) {
        return this.dataService.updateDataType(this.id, { unit_id: value }, this);
    }
    get unitId() {
        return this._unitId;
    }
    set unitDetails(value) {
        console.error('Do not set objects this way');
    }
    setUnitDetails(value) {
        return this.dataService.updateDataType(this.id, { unit_details: value }, this);
    }
    get unitDetails() {
        return this._unitDetails;
    }
    set applyRate(value) {
        console.error('Do not set objects this way');
    }
    setApplyRate(value) {
        return this.dataService.updateDataType(this.id, { apply_rate: value }, this);
    }
    get applyRate() {
        return this._applyRate;
    }
    set rateUnitId(value) {
        console.error('Do not set objects this way');
    }
    setRateUnitId(value) {
        return this.dataService.updateDataType(this.id, { rate_unit_id: value }, this);
    }
    get rateUnitId() {
        return this._rateUnitId;
    }
    set rateUnitDetails(value) {
        console.error('Do not set objects this way');
    }
    setRateUnitDetails(value) {
        return this.dataService.updateDataType(this.id, { rate_unit_details: value }, this);
    }
    get rateUnitDetails() {
        return this._rateUnitDetails;
    }
    set categoryId(value) {
        console.error('Do not set objects this way');
    }
    setCategoryId(value) {
        return this.dataService.updateDataType(this.id, { category_id: value }, this);
    }
    get categoryId() {
        return this._categoryId;
    }
    set categoryDetails(value) {
        console.error('Do not set objects this way');
    }
    setCategoryDetails(value) {
        return this.dataService.updateDataType(this.id, { category_details: value }, this);
    }
    get categoryDetails() {
        return this._categoryDetails;
    }
    set global(value) {
        console.error('Do not set objects this way');
    }
    setGlobal(value) {
        return this.dataService.updateDataType(this.id, { global: value }, this);
    }
    get global() {
        return this._global;
    }
    set defaultRateMultiple(value) {
        console.error('Do not set objects this way');
    }
    setDefaultRateMultiple(value) {
        return this.dataService.updateDataType(this.id, { default_rate_multiple: value }, this);
    }
    get defaultRateMultiple() {
        return this._defaultRateMultiple;
    }
    set defaultMultiple(value) {
        console.error('Do not set objects this way');
    }
    setDefaultMultiple(value) {
        return this.dataService.updateDataType(this.id, { default_multiple: value }, this);
    }
    get defaultMultiple() {
        return this._defaultMultiple;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateDataType(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateDataType(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteDataType(this.id, this);
    }
}
exports.default = DataType;
//# sourceMappingURL=dataType.js.map